import {
  useEffect 
} from "react"
const OPTIONS_DEFAULTS = {
  behavior: "smooth", block: "center" 
}

export const useScrollIntoView = (
  ref,
  shouldScroll,
  options = OPTIONS_DEFAULTS
) => {
  useEffect(() => {
    if (ref.current && ref.current instanceof HTMLElement && shouldScroll) {
      ref.current.scrollIntoView(options)
    }
  }, [options, ref, shouldScroll])
}
